import { style } from '@vanilla-extract/css';

export const orderContainer = style({
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  fontVariantNumeric: 'tabular-nums',
});
